/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { isArray, isEmpty, set } from 'lodash';
import { Container, Row, Col } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useGradingGroupState } from './GradingGroupProvider';
import * as action from '../Store/Pom.action';
import { getMultiSubBrandDetails } from '../../../SystemMasters/Store/SystemMasters.action';
import { getSizeRangesMasterDetails } from '../../../SystemMasters/Store/SizeRangeMaster.action';

function TopGroupBar() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const { gradingGroupState, setgradingGroup, loggedInUserId, GradingAddEditAccess } = useGradingGroupState();
  const { selectCategoryOne, selectCategoryTwo, selectGradingBrand, selectCategoryThree, selectSubBrand } = gradingGroupState;
  const reducerState = useSelector((redState) => redState);
  const {
    PomDetails: { GradingDataById },
    SystemMastersDetails: { sizeRangesMasterList },
  } = reducerState;

  const mergeInactiveSelected = (baseOptions = [], selected = [], editSelectedObjs = []) => {
    const baseById = new Map((baseOptions || []).map((o) => [o?._id, o]));
    const normalizeToIds = (arr) => (Array.isArray(arr) ? arr : [arr]).map((x) => x?._id || x).filter(Boolean);
    const selectedIds = normalizeToIds(selected);
    const editById = new Map((Array.isArray(editSelectedObjs) ? editSelectedObjs : [editSelectedObjs]).filter(Boolean).map((o) => [o?._id, o]));
    const missing = [];
    selectedIds.forEach((id) => {
      if (!baseById.has(id)) {
        const ref = editById.get(id) || { _id: id, name: '' };
        const fallbackLabel = ref?.name || 'Loading...';
        missing.push({
          _id: id,
          name: fallbackLabel,
          label: fallbackLabel,
          value: id,
          disabled: true,
        });
      }
    });

    // De-duplicate and return merged options
    return [...baseOptions, ...missing.filter((m) => !baseById.has(m._id))];
  };

  const normalizedSizeRangesMasterList = useMemo(() => {
    if (Array.isArray(sizeRangesMasterList)) return sizeRangesMasterList;
    if (Array.isArray(sizeRangesMasterList?.data)) return sizeRangesMasterList.data;
    return [];
  }, [sizeRangesMasterList]);

  const sizeRangeDropdownOptions = useMemo(() => {
    return (
      normalizedSizeRangesMasterList
        ?.filter((range) => !range?.isDeleted && range?.isActive)
        ?.map((range) => ({
          label: range?.name ?? '',
          value: range?._id,
          _id: range?._id,
        })) ?? []
    );
  }, [normalizedSizeRangesMasterList]);
  useEffect(() => {
    if (!isEmpty(selectCategoryOne) && !isEmpty(selectCategoryTwo)) {
      const queryParams = {
        isActive: 1,
        loggedInUserId,
        categoryOneId: selectCategoryOne,
        categoryTwoId: selectCategoryTwo,
        categoryType: 3,
      };
      // When categories are driven by Product Type, include productTypeId for consistency
      if (gradingGroupState?.catBasedOnPTData) {
        queryParams.productTypeId = gradingGroupState?.productTypeId || [];
      }
      dispatch(action.fetchCategoryThreeForGrading(queryParams));
    }
  }, [selectCategoryOne, selectCategoryTwo, loggedInUserId, dispatch, gradingGroupState?.catBasedOnPTData, gradingGroupState?.productTypeId]);

  useEffect(() => {
    if (!isEmpty(selectGradingBrand)) {
      const queryParams = {
        brandId: selectGradingBrand,
      };
      dispatch(getMultiSubBrandDetails(queryParams));
    }
  }, [selectGradingBrand, dispatch]);

  useEffect(() => {
    if (isEmpty(selectCategoryOne) || isEmpty(selectCategoryTwo)) {
      setgradingGroup((prev) => ({
        ...prev,
        CategoryThreeData: [],
        selectCategoryThree: [],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCategoryOne, selectCategoryTwo]);

  useEffect(() => {
    if (isEmpty(selectGradingBrand)) {
      setgradingGroup((prev) => ({
        ...prev,
        subBrandOptions: [],
        selectSubBrand: [],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectGradingBrand]);

  useEffect(() => {
    if (gradingGroupState?.subBrandOptions?.length > 0 && gradingGroupState?.selectSubBrand?.length > 0 && gradingGroupState?.isSubBrandAccess) {
      const availableSubBrandIds = gradingGroupState.subBrandOptions.map((option) => option._id);
      const filteredSelectedSubBrands = gradingGroupState.selectSubBrand.filter((subBrandId) => availableSubBrandIds.includes(subBrandId));

      if (filteredSelectedSubBrands?.length !== gradingGroupState?.selectSubBrand?.length) {
        setgradingGroup((prev) => ({
          ...prev,
          selectSubBrand: filteredSelectedSubBrands,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradingGroupState.subBrandOptions, gradingGroupState.selectGradingBrand]);

  useEffect(() => {
    if (gradingGroupState?.catBasedOnPTData && gradingGroupState?.CategoryOneData?.length > 0 && gradingGroupState?.selectCategoryOne?.length > 0) {
      const availableCat1Ids = (gradingGroupState?.CategoryOneData || []).map((option) => option._id);
      const normalizedSelected = (gradingGroupState.selectCategoryOne || []).map((x) => x?._id || x).filter(Boolean);
      const filteredSelectedCat1 = normalizedSelected.filter((catId) => availableCat1Ids.includes(catId));

      if (filteredSelectedCat1?.length !== normalizedSelected?.length) {
        setgradingGroup((prev) => ({
          ...prev,
          selectCategoryOne: filteredSelectedCat1,
        }));
      }
    }
    if (gradingGroupState?.CategoryOneData?.length === 0 && gradingGroupState?.selectCategoryOne?.length > 0) {
      setgradingGroup((prev) => ({
        ...prev,
        selectCategoryOne: [],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradingGroupState.CategoryOneData, gradingGroupState?.selectCategoryOne, gradingGroupState.catBasedOnPTData]);

  useEffect(() => {
    if (gradingGroupState?.catBasedOnPTData && gradingGroupState?.CategoryTwoData?.length > 0 && gradingGroupState?.selectCategoryTwo?.length > 0) {
      const availableCat2Ids = (gradingGroupState?.CategoryTwoData || []).map((option) => option._id);
      const normalizedSelected = (gradingGroupState.selectCategoryTwo || []).map((x) => x?._id || x).filter(Boolean);
      const filteredSelectedCat = normalizedSelected.filter((catId) => availableCat2Ids.includes(catId));

      if (filteredSelectedCat?.length !== normalizedSelected?.length) {
        setgradingGroup((prev) => ({
          ...prev,
          selectCategoryTwo: filteredSelectedCat,
        }));
      }
    }
  }, [gradingGroupState.CategoryTwoData, gradingGroupState?.selectCategoryTwo, gradingGroupState.catBasedOnPTData]);

  useEffect(() => {
    if (gradingGroupState?.CategoryThreeData?.length > 0 && gradingGroupState?.selectCategoryThree?.length > 0) {
      const availableCat3Ids = gradingGroupState.CategoryThreeData.map((option) => option._id);
      const normalizedSelected = (gradingGroupState.selectCategoryThree || []).map((x) => x?._id || x).filter(Boolean);
      const filteredSelectedCat3 = normalizedSelected.filter((catId) => availableCat3Ids.includes(catId));

      if (filteredSelectedCat3?.length !== normalizedSelected?.length) {
        setgradingGroup((prev) => ({
          ...prev,
          selectCategoryThree: filteredSelectedCat3,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradingGroupState.CategoryThreeData]);

  useEffect(() => {
    if (loggedInUserId && isEmpty(sizeRangesMasterList)) {
      dispatch(getSizeRangesMasterDetails({ loggedInUserId }));
    }
  }, [loggedInUserId, dispatch, sizeRangesMasterList]);

  const handleSelectChange = (value, keyName) => {
    const nextState = { ...gradingGroupState };
    if (isArray(value) && isEmpty(value)) {
      set(nextState, keyName, [...value]);
    } else {
      set(nextState, keyName, value);
    }

    if (keyName === 'sizeRangeId' && gradingGroupState?.isAdd) {
      const selectedSizes = sizeRangesMasterList.find((item) => item._id === value)?.sizes || [];
      const sizesToAdd = selectedSizes.map((size) => ({
        name: size.name,
        isSampleSize: false,
      }));
      const newSizeRangesForHeader = sizesToAdd.map((item) => ({
        sizeName: item.name,
        isSampleSize: item.isSampleSize,
        isZero: !!item.isSampleSize,
      }));
      set(nextState, 'sizeRanges', sizesToAdd);
      set(nextState, 'sizeRangesForHeader', newSizeRangesForHeader);
      set(nextState, 'applySizeRangesToHeaderText', true);

      if (gradingGroupState?.pomTableData?.length > 0) {
        const updatedPomTableData = gradingGroupState.pomTableData.map((pom) => {
          const newGradings = newSizeRangesForHeader.map((headerItem) => {
            const existingGrading = (pom.gradings || []).find((g) => g.sizeName === headerItem.sizeName);
            return {
              sizeName: headerItem.sizeName,
              isSampleSize: headerItem.isSampleSize,
              isZero: headerItem.isZero,
              grading: existingGrading?.grading ?? 0,
            };
          });
          return { ...pom, gradings: newGradings };
        });
        set(nextState, 'pomTableData', updatedPomTableData);
      }
    }
    setgradingGroup((prevState) => ({ ...prevState, ...nextState }));
  };

  return (
    <Container fluid className="pom-top-bar mt-3">
      <Row>
        <Col md={3}>
          <div className="common-input-control">
            <p className="field-name">
              {t('POMS.GRADING_GROUP.TOP_GROUP_BAR.GROUP_NAME')} <span className="asterisk">*</span>
            </p>
            <input
              autoComplete="off"
              type="text"
              value={gradingGroupState?.groupName}
              name="groupName"
              className="form-control"
              onChange={(e) => handleSelectChange(e.target.value.trimStart(), 'groupName')}
              disabled={!GradingAddEditAccess}
            />
            {gradingGroupState?.showError && !gradingGroupState?.groupName && (
              <small className="error-message">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.GROUP_NAME_REQUIRED')}</small>
            )}
          </div>
        </Col>
        <Col md={9}>
          <div className="common-input-control">
            <p className="field-name">
              {t('POMS.GRADING_GROUP.TOP_GROUP_BAR.GROUP_DESCRIPTION')} <span className="asterisk">*</span>
            </p>
            <input
              autoComplete="off"
              type="text"
              value={gradingGroupState?.groupDescription}
              name="groupDescription"
              className="form-control"
              onChange={(e) => handleSelectChange(e.target.value.trimStart(), 'groupDescription')}
              disabled={!GradingAddEditAccess}
              maxLength={200}
            />
            <div className="text-count">
              {gradingGroupState?.groupDescription?.length}/{200}
            </div>
            {gradingGroupState?.showError && !gradingGroupState?.groupDescription && (
              <small className="error-message">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.GROUP_DES_REQUIRED')}</small>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <div className="common-react-select">
            <p className="field-name">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.BRAND')}</p>
            <MultiSelect
              name="Brand"
              options={gradingGroupState?.BrandData.map((e) => ({
                ...e,
                disabled: GradingDataById?.isUsedBrand?.includes(e._id),
              }))}
              className="product-custom-multiselect common-new-multiselect"
              value={mergeInactiveSelected(gradingGroupState?.BrandData, selectGradingBrand, GradingDataById?.brandId || []).filter((val) =>
                (selectGradingBrand || [])?.includes(val?._id),
              )}
              labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.BRAND_NOT_SELECTED')}
              onChange={(selected) => {
                const selectedIds = selected.map((val) => val?._id);
                const usedIds = GradingDataById?.isUsedBrand || [];
                const protectedIds = (selectGradingBrand || []).filter((id) => usedIds.includes(id) && !selectedIds.includes(id));
                handleSelectChange([...selectedIds, ...protectedIds], 'selectGradingBrand');
              }}
              disabled={!GradingAddEditAccess}
            />
          </div>
        </Col>
        {gradingGroupState?.isSubBrandAccess && (
          <Col md={3}>
            <div className="common-react-select mb-0">
              <p className="field-name">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SUB_BRAND')}</p>
              <MultiSelect
                name="SubBrand"
                options={(gradingGroupState?.subBrandOptions?.filter((e) => e.isActive) || []).map((e) => ({
                  ...e,
                  disabled: GradingDataById?.isUsedSubBrand?.includes(e._id),
                }))}
                className="product-custom-multiselect common-new-multiselect"
                value={mergeInactiveSelected(gradingGroupState?.subBrandOptions, selectSubBrand, GradingDataById?.subBrandId || []).filter((val) =>
                  (selectSubBrand || [])?.includes(val?._id),
                )}
                labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SUB_BRAND_NOT_SELECTED')}
                onChange={(selected) => {
                  const selectedIds = selected.map((val) => val?._id);
                  const usedIds = GradingDataById?.isUsedSubBrand || [];
                  const protectedIds = (selectSubBrand || []).filter((id) => usedIds.includes(id) && !selectedIds.includes(id));
                  handleSelectChange([...selectedIds, ...protectedIds], 'selectSubBrand');
                }}
                disabled={!GradingAddEditAccess}
              />
            </div>
          </Col>
        )}
        {gradingGroupState?.catBasedOnPTData && (
          <Col md={3}>
            <div className="common-react-select mb-0">
              <p className="field-name">
                Product Type
                <span className="asterisk">*</span>
              </p>
              <MultiSelect
                name="productType"
                options={gradingGroupState?.productTypeData.map((e) => ({
                  ...e,
                  disabled: GradingDataById?.isUsedSupplierType?.includes(e._id),
                }))}
                className="product-custom-multiselect common-new-multiselect"
                value={mergeInactiveSelected(
                  gradingGroupState?.productTypeData,
                  gradingGroupState?.productTypeId,
                  GradingDataById?.productType || GradingDataById?.productTypeId || GradingDataById?.productTypeIds || [],
                ).filter((val) => (gradingGroupState?.productTypeId || [])?.includes(val?._id))}
                labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.BRAND_NOT_SELECTED')}
                onChange={(selected) => {
                  const selectedIds = selected.map((val) => val?._id);
                  const usedIds = GradingDataById?.isUsedSupplierType || [];
                  const protectedIds = (gradingGroupState?.productTypeId || []).filter((id) => usedIds.includes(id) && !selectedIds.includes(id));
                  handleSelectChange([...selectedIds, ...protectedIds], 'productTypeId');
                }}
                disabled={!GradingAddEditAccess}
              />
              {gradingGroupState?.showError && !gradingGroupState?.productTypeId?.length && <small className="error-message">Product Type is required</small>}
            </div>
          </Col>
        )}
        <Col md={3}>
          <div className="common-react-select mb-0">
            <p className="field-name">
              {t('POMS.GRADING_GROUP.TOP_GROUP_BAR.CATEGO0RY_1')}
              <span className="asterisk">*</span>
            </p>
            <MultiSelect
              name="CategoryOne"
              options={gradingGroupState?.CategoryOneData.map((e) => ({
                ...e,
                disabled: GradingDataById?.isUsedCat1?.includes(e._id),
              }))}
              className="product-custom-multiselect common-new-multiselect"
              value={mergeInactiveSelected(gradingGroupState?.CategoryOneData, selectCategoryOne, GradingDataById?.catsOneIds || []).filter((val) =>
                (selectCategoryOne || [])?.map((x) => x?._id || x).includes(val?._id),
              )}
              labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.BRAND_NOT_SELECTED')}
              onChange={(selected) => {
                const selectedIds = selected.map((val) => val?._id);
                const usedIds = GradingDataById?.isUsedCat1 || [];
                const protectedIds = (selectCategoryOne || []).filter((id) => usedIds.includes(id) && !selectedIds.includes(id));
                handleSelectChange([...selectedIds, ...protectedIds], 'selectCategoryOne');
              }}
              disabled={!GradingAddEditAccess}
            />
            {gradingGroupState?.showError && !gradingGroupState?.selectCategoryOne?.length && (
              <small className="error-message">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.CATEGORY_1_SELECTION_REQUIRED')}</small>
            )}
          </div>
        </Col>

        <Col md={3}>
          <div className="common-react-select mb-0">
            <p className="field-name mt-0">
              {t('POMS.GRADING_GROUP.TOP_GROUP_BAR.CATEGORY_2')}
              <span className="asterisk">*</span>
            </p>
            <MultiSelect
              name="CategoryTwo"
              options={gradingGroupState?.CategoryTwoData.map((e) => ({
                ...e,
                disabled: GradingDataById?.isUsedCat2?.includes(e._id),
              }))}
              className="product-custom-multiselect common-new-multiselect"
              value={mergeInactiveSelected(gradingGroupState?.CategoryTwoData, selectCategoryTwo, GradingDataById?.catsTwoIds || []).filter((val) =>
                (selectCategoryTwo || [])?.map((x) => x?._id || x).includes(val?._id),
              )}
              labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.BRAND_SELECTED')}
              onChange={(selected) => {
                const selectedIds = selected.map((val) => val?._id);
                const usedIds = GradingDataById?.isUsedCat2 || [];
                const protectedIds = (selectCategoryTwo || []).filter((id) => usedIds.includes(id) && !selectedIds.includes(id));
                handleSelectChange([...selectedIds, ...protectedIds], 'selectCategoryTwo');
              }}
              disabled={!GradingAddEditAccess}
            />
            {gradingGroupState?.showError && !gradingGroupState?.selectCategoryTwo?.length && (
              <small className="error-message">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.CATEGORY_SELECTION_REQUIRED')}</small>
            )}
          </div>
        </Col>

        <Col md={3}>
          <div className="common-react-select mb-0 ">
            <p className="field-name mt-0">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.CATEGORIES_3')}</p>
            <MultiSelect
              name="CategoryThree"
              options={gradingGroupState?.CategoryThreeData.map((e) => ({
                ...e,
                disabled: GradingDataById?.isUsedCat3?.includes(e._id),
              }))}
              className="product-custom-multiselect common-new-multiselect"
              value={mergeInactiveSelected(gradingGroupState?.CategoryThreeData, selectCategoryThree, GradingDataById?.catThreeId || []).filter((val) =>
                (selectCategoryThree || [])?.map((x) => x?._id || x).includes(val?._id),
              )}
              labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.BRAND_SELECTED')}
              onChange={(selected) => {
                const selectedIds = selected.map((val) => val?._id);
                const usedIds = GradingDataById?.isUsedCat3 || [];
                const protectedIds = (selectCategoryThree || []).filter((id) => usedIds.includes(id) && !selectedIds.includes(id));
                handleSelectChange([...selectedIds, ...protectedIds], 'selectCategoryThree');
              }}
              disabled={!GradingAddEditAccess}
            />
          </div>
        </Col>
        <Col md={3}>
          <div className="common-react-select mb-0">
            <p className="field-name mt-0">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SIZE_RANGE')}</p>
            <Select
              name="sizeRange"
              options={sizeRangeDropdownOptions}
              value={sizeRangeDropdownOptions.find((val) => val.value === gradingGroupState?.sizeRangeId) || null}
              onChange={(selected) => {
                handleSelectChange(selected?.value || null, 'sizeRangeId');
              }}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              className="common-select"
              classNamePrefix="common-select"
              placeholder={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SIZE_RANGE')}
              isClearable
              isDisabled={!GradingAddEditAccess}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default TopGroupBar;
